import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/api";

export default function PaymentResult({ mode }) {
  const [params] = useSearchParams();
  const [status, setStatus] = useState(mode === "success" ? "checking" : "cancelled");

  useEffect(() => {
    if (mode !== "success") return;
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setStatus("error");
      return;
    }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
      } catch (e) { /* keep polling */ }
      tries += 1;
      if (tries < 10) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
  }, [mode, params]);

  const copy = {
    checking: { title: "Confirming your adoption...", body: "Hold tight while Stripe confirms your bear." },
    paid: { title: "Your bear is coming home.", body: "Adoption confirmed. Thank you for moving the counter toward 1,000 — check your inbox for confirmation." },
    pending: { title: "Almost there.", body: "Your payment is still processing. It will confirm shortly — thank you for adopting." },
    cancelled: { title: "No worries.", body: "Checkout was cancelled. Your bear will wait patiently — adopt whenever you're ready." },
    error: { title: "Hmm, something's off.", body: "We couldn't find that checkout session. If you completed payment, it will still count." },
  }[status];

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-transparent px-6 text-center" data-testid={`payment-${mode}-page`}>
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
        <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.4em] text-[#8A5A0F]">Kindness Bear Adoption</p>
        <h1 className="mb-6 font-serif text-5xl font-black text-[#33240E]" data-testid="payment-result-title">{copy.title}</h1>
        <p className="mx-auto mb-10 max-w-md text-base font-light text-muted-foreground" data-testid="payment-result-body">{copy.body}</p>
        <Link to="/" data-testid="payment-home-link"
          className="inline-block bg-[#33240E] px-8 py-4 font-mono text-xs uppercase tracking-[0.25em] text-[#F6E7C1] transition-colors duration-300 hover:bg-[#4A3517]">
          Back to the Movement
        </Link>
      </motion.div>
    </div>
  );
}
